import { useState, useCallback } from 'react';
import { logInfo } from '../../../../../utils/logger';

export const useMapState = (settings) => {
  const [mapState, setMapState] = useState({
    mapType: settings?.preferences?.mapSettings?.defaultMapType || 'roadmap',
    mode: 'pan',
    showRoutePlanner: false,
    showDirections: false
  });

  const handleMapTypeChange = useCallback((type) => {
    setMapState(prev => ({ ...prev, mapType: type }));
    logInfo(`Map type changed to ${type}`);
  }, []);

  const handleModeChange = useCallback((mode) => {
    setMapState(prev => ({ ...prev, mode }));
    logInfo(`Map mode changed to ${mode}`);
  }, []);

  const toggleRoutePlanner = useCallback((show) => {
    setMapState(prev => ({
      ...prev,
      showRoutePlanner: show,
      mode: show ? 'route' : 'pan'
    }));
    logInfo(`Route planner ${show ? 'shown' : 'hidden'}`);
  }, []);

  const toggleDirections = useCallback(() => {
    setMapState(prev => ({
      ...prev,
      showDirections: !prev.showDirections
    }));
  }, []);

  return {
    mapState,
    handleMapTypeChange,
    handleModeChange,
    toggleRoutePlanner,
    toggleDirections
  };
};